// extracted by mini-css-extract-plugin
export default {"root":"Navigation_root__Si5kp","rootCard":"Navigation_rootCard__Vc68o","navItem":"Navigation_navItem__tvd8J","navItemSelected":"Navigation_navItemSelected__OXc1L"};